"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingBox = void 0;
const react_1 = __importStar(require("react"));
const buttons_1 = require("../../buttons");
const forms_1 = require("../../forms");
const popovers_1 = require("../../modals/popovers");
const SettingsBox_styles_1 = require("./SettingsBox.styles");
const SettingBox = ({ title, controls, description, buttonLabel, showButton, showLine, toastMessage, toastDuration, buttonOnClick, translationKey, translationEditHandler, }) => {
    const valueObj = {};
    controls.forEach((c) => {
        if (c.key) {
            valueObj[c.key] = c.value;
        }
    });
    const [values, setValue] = (0, react_1.useState)(valueObj);
    const [showToast, setShowToast] = (0, react_1.useState)(false);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(SettingsBox_styles_1.Title, { "$inlineTranslation": !!translationKey }, translationKey ? (react_1.default.createElement(forms_1.EditableTitle, { name: title, editHandler: (isCancelled, value) => translationEditHandler && value && translationEditHandler(isCancelled, value), isEditable: !!translationKey })) : (title)),
        description && react_1.default.createElement(SettingsBox_styles_1.DescriptionWrapper, null, description),
        react_1.default.createElement(SettingsBox_styles_1.ControlsWrapper, null, controls.map((control, index) => {
            return (react_1.default.createElement(SettingsBox_styles_1.InputFieldWrapper, { key: "" + control.key + index },
                react_1.default.createElement(forms_1.InputFieldCompact, { label: control.label, value: control.value, type: control.type, placeholder: control.placeholder, options: control.options, errorText: control.error ? "Error" : undefined, subtitleText: control.informationText, onChange: (value) => {
                        if (showButton && control.key) {
                            setValue(Object.assign(Object.assign({}, values), { [control.key]: value }));
                        }
                        else {
                            if (control.onChange)
                                control.onChange(value);
                        }
                    } })));
        })),
        showButton && (react_1.default.createElement(SettingsBox_styles_1.ButtonWrapper, null,
            react_1.default.createElement(buttons_1.Button, { label: buttonLabel, onClick: () => {
                    if (buttonOnClick !== undefined) {
                        buttonOnClick(values);
                    }
                    setShowToast(true);
                } }),
            showToast && toastMessage && toastDuration && (react_1.default.createElement(popovers_1.ElevatedSnackBar, { message: toastMessage, duration: toastDuration, id: "setting-box-save-toast", onClose: () => setShowToast(false) })))),
        showLine && react_1.default.createElement(SettingsBox_styles_1.HorizontalLine, null)));
};
exports.SettingBox = SettingBox;
//# sourceMappingURL=SettingsBox.js.map